module.exports = __webpack_public_path__ + "img/600.ed7cbe92.svg";